import toast from "react-hot-toast";
import usePut from "../usePut"
import { throwError } from "../../utility/errorHandling";

const useBulkUploadAttendance = ({
    onSuccess,
    uploadType = 'bulk'
}) => {
    const endpointMap = {
        bulk: 'excelUploadAttendance',
        monthly: 'monthly_attendance_count_excel_upload'
    };

    const { handleAuth: handlePost } = usePut({
        url: endpointMap[uploadType],
        refreshUrl: 'employeelist',
        onSuccess: (res) => {
            onSuccess?.()
            toast.success('Attendance uploaded successfully')
        },
        onError: (err) => {
            throwError(err)
        }
    })
    const handleUploadAttendance = (data) => {
        handlePost.mutate(data)
    }
    return { handleUploadAttendance, handlePost }
}

export default useBulkUploadAttendance